module.exports = __webpack_public_path__ + "static/musik-46f2107f763d58dcbda7a91a20c37ef7.jpg";